export const RenewalPolicyFragment = gql`
  fragment RenewalPolicyFragment on RenewalPolicy {
    id
    name
    renewalMethod
    renewalWindowValue
    renewalWindowUnit
    gracePeriodValue
    gracePeriodUnit
    latePeriodValue
    latePeriodUnit
    archivedAt
    expirationDateTemplate {
      ...DateTemplateFragment
    }
    renewalFees {
      id
      fee {
        id
        name
      }
    }
    renewalPolicyEmails {
      id
      phase
      daysOffset
      emailContent
    }
    assignedRecordTemplates {
      id
      name
      archivedAt
    }
  }
`
